import { api } from "@/api";
export const globalSupplierStore = {
  state: {
    globalSuppliers: []
  },
  getters: {
    getGlobalSuppliers(state) {
      return state.globalSuppliers;
    }
  },
  mutations: {
    setGlobalSuppliers(state, value) {
      state.globalSuppliers = value;
    }
  },
  actions: {
    async loadGlobalSuppliers(context) {
      const res = await api.getGlobalSuppliers();
      context.commit("setGlobalSuppliers", res);
    }
  }
};
